<template>
  <Splash :content="`Welcome to Film ID. Try searching for something.`"></Splash>
</template>
<script>
import Splash from '@/components/Splash'
export default {
  components: {
    Splash
  }
}
</script>
